import { Injectable } from '@angular/core';
import { HrApiClient } from './shared/hr-api-client';
import { withHrDashboardApi } from './dashboard/hr-dashboard.api';
import { withHrSelfServiceApi } from './self-service/hr-self-service.api';
import { withHrCasesApi } from './cases/hr-cases.api';
import { withHrCountryPacksApi } from './country-packs/hr-country-packs.api';
import { withHrRecruitmentApi } from './recruitment/hr-recruitment.api';
import { withHrLearningApi } from './learning/hr-learning.api';
import { withHrPerformanceApi } from './performance/hr-performance.api';
import { withHrLeaveApi } from './leave/hr-leave.api';
import { withHrTimeApi } from './time/hr-time.api';
import { withHrRosterApi } from './roster/hr-roster.api';
import { withHrEmployeeApi } from './employee/hr-employee.api';
import { withHrDocumentsApi } from './documents/hr-documents.api';
import { withHrLifecycleApi } from './lifecycle/hr-lifecycle.api';
import { withHrSetupApi } from './setup/hr-setup.api';
import { withHrMigrationApi } from './migration/hr-migration.api';
import { withHrReadinessApi } from './readiness/hr-readiness.api';
import { withHrPayrollApi } from './payroll/hr-payroll.api';
import { withHrAnalyticsApi } from './analytics/hr-analytics.api';
import { withHrAdminOperationsApi } from './admin-operations/hr-admin-operations.api';
import { withHrLaborApi } from './labor/hr-labor.api';

const HrApiComposition = withHrLaborApi(withHrAdminOperationsApi(withHrDashboardApi(withHrSelfServiceApi(withHrCasesApi(withHrCountryPacksApi(withHrRecruitmentApi(withHrLearningApi(withHrPerformanceApi(withHrLeaveApi(withHrTimeApi(withHrRosterApi(withHrEmployeeApi(withHrDocumentsApi(withHrLifecycleApi(withHrSetupApi(withHrMigrationApi(withHrReadinessApi(withHrPayrollApi(withHrAnalyticsApi(HrApiClient))))))))))))))))))));

@Injectable({ providedIn: 'root' })
export class HrService extends HrApiComposition {}
